import styled from 'styled-components';

export const AdvertiseStyled = styled.div<{ $ishide: boolean }>`
  height: 40px;
  background-color: ${({ theme }) => theme.colors.greenLight};
  display: ${({ $ishide }) => ($ishide ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  gap: 8px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 80px;
  }
  .main-text {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    & .small-screen-text {
      display: inline-block;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: none;
      }
    }
    & .large-screen-text {
      display: none;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: inline-block;
      }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      gap: 15px;
    }
  }
`;
